{
  "name": "@ns/company-hmrc-validation",
  "version": "1.1.0",
  "description": "Validate your company using companies house",
  "inputs": {},
  "outcomes": {
    "complete": {},
    "skip": {}
  },
  "publicLedger": [
    {
      "id": "validation-message",
      "outcome": "complete",
      "kind": "INTERNAL_MESSAGE"
    }
  ]
}
